import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=7e0b4b18&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports